import { Box, IconButton, Typography } from "@mui/material";
import { dummy } from "../assets/assets";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";

interface IProps {
  image?: string;
  name: string;
  designation: string;
  linkedIn?: string;
  instagram?: string;
  twitter?: string;
}

const TeamMermberCard = (props: IProps) => {
  const { image, designation, name } = props;
  return (
    <Box className="team-member">
      <Box
        component="img"
        src={image ?? dummy}
        alt="Placeholder"
        className="profile-pic"
      />
      <Box className="member-info">
        <Typography variant="h4">{name}</Typography>
        <p>{designation}</p>
        {false && (
          <Box className="social-buttons">
            <IconButton aria-label="linkedIn">
              <LinkedInIcon className="social-button" />
            </IconButton>
            <IconButton aria-label="linkedIn">
              <XIcon className="social-button" />
            </IconButton>
            <IconButton aria-label="linkedIn">
              <InstagramIcon className="social-button" />
            </IconButton>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TeamMermberCard;
